import script from "./JumpToMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./JumpToMenu.vue?vue&type=script&setup=true&lang=ts"

import "./JumpToMenu.vue?vue&type=style&index=0&id=40099a85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40099a85"]])

export default __exports__